import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';

interface CustomSignupLinkResultProps {
  url?: string;
  onCopy?: () => void;
  onClose?: () => void;
  onOpen?: () => void;
}

export const CustomSignupLinkResult = ({
  url,
  onCopy,
  onClose,
  onOpen,
}: CustomSignupLinkResultProps) => {
  if (!url) {
    return null;
  }

  return (
    <Box mt={3}>
      <Stack direction="row" alignItems="center" spacing={1} mb={1.5}>
        <CheckCircleOutlineIcon color="success" fontSize="small" />
        <Typography variant="body2">Checkout URL generated successfully.</Typography>
      </Stack>

      <Stack direction="row" spacing={1.5} justifyContent="flex-end" mb={1.5}>
        <Button
          startIcon={<ContentCopyIcon />}
          onClick={onCopy}
          data-testid="custom-signup-link-copy"
        >
          Copy
        </Button>
      </Stack>

      <TextField
        data-testid="custom-signup-link-url"
        fullWidth
        multiline
        minRows={3}
        value={url}
        InputProps={{
          readOnly: true,
        }}
      />

      <Stack direction="row" spacing={1.5} justifyContent="flex-end" mt={2}>
        <Button onClick={onClose} data-testid="custom-signup-link-close">
          Close
        </Button>
        <Button
          variant="contained"
          startIcon={<LaunchIcon />}
          onClick={onOpen}
          data-testid="custom-signup-link-open"
        >
          Open in new tab
        </Button>
      </Stack>
    </Box>
  );
};
